import React, {RefCallback} from 'react';

/**
 * This hook to increase perfomance of hook forms, because ref is always a new object and causes rerenders
 * @param ref Ref
 * @returns
 */
export function useMemoRef<T extends RefCallback<any> | null>(ref: T) {
   const _ref = React.useRef(ref);
   _ref.current = ref;
   const _refCb = React.useCallback(
      (e: any) => {
         _ref.current?.(e);
      },
      [_ref]
   );

   return _refCb;
}
